import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";

interface DropdownMenuProps {
  label: string;
  value: string;
  onChange: (event: SelectChangeEvent) => void;
  options: { value: string; label: string }[];
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  label,
  value,
  onChange,
  options,
}) => {
  return (
    <FormControl size="small" sx={{ width: 224 }}>
      <InputLabel id="dropdown-label">{label}</InputLabel>
      <Select
        labelId="dropdown-label"
        value={value}
        label={label}
        onChange={onChange}
        MenuProps={{
          PaperProps: {
            sx: {
              "& .MuiMenuItem-root": {
                height: 40,
                display: "flex",
                alignItems: "center",
              },
            },
          },
        }}
        sx={{ textAlign: "left" }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DropdownMenu;
